import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { HugeiconsIcon } from '@hugeicons/react'
import { NoteAddIcon } from '@hugeicons-pro/core-bulk-rounded'
import { Note04Icon } from '@hugeicons-pro/core-duotone-rounded'
import { Button } from '@mui/material'

import { selectOrder } from '@/app/services/orders'
import { selectOrganisationId, selectPaidFeatures } from '@/app/slices/organisationSlice'

import OrderNotesModal from './OrderNotesModal'

const OrderNotes = () => {
    const { t } = useTranslation()
    const { orderId } = useParams()

    const organisationId = useSelector(selectOrganisationId)
    const selectedOrder = useSelector((state) => selectOrder(state, { organisationId, orderId }))
    const paidFeatures = useSelector(selectPaidFeatures)

    const [showOrderNotesDialog, setShowOrderNotesDialog] = useState(false)

    const orderHasNotes = selectedOrder?.vendorNotes || selectedOrder?.privateNotes

    const disableOrderNotesButton = paidFeatures?.isFreePlan

    const handleOrderNotesButtonClick = () => {
        setShowOrderNotesDialog(true)
    }

    const handleOrderNotesDialogClose = () => {
        setShowOrderNotesDialog(false)
    }

    return (
        <>
            <Button
                color="secondary"
                data-testid="order-notes-button"
                disabled={disableOrderNotesButton}
                size="small"
                startIcon={
                    <HugeiconsIcon
                        altIcon={Note04Icon}
                        icon={NoteAddIcon}
                        showAlt={orderHasNotes}
                    />
                }
                variant="outlined"
                onClick={handleOrderNotesButtonClick}
            >
                {orderHasNotes ? t('Order notes') : t('Add notes to order')}
            </Button>

            <OrderNotesModal
                open={showOrderNotesDialog}
                order={selectedOrder}
                onClose={handleOrderNotesDialogClose}
            />
        </>
    )
}

export default OrderNotes
